import { useEffect, useState } from 'react';
import Shell from '../components/Shell';
import type { Branding } from '../types';

interface ThankYouPageProps {
  branding: Branding;
  // step === 'done'. Until then the flow keeps polling, so the redirect only
  // happens once the verification has been delivered.
  done: boolean;
  redirectUrl: string | null;
}

const REDIRECT_DELAY_SECONDS = 5;

// The person never learns the verdict (PLAN-Verification-Journeys.md D4): the
// same neutral page for every outcome — no heading per status, no reason.
export default function ThankYouPage({ branding, done, redirectUrl }: ThankYouPageProps) {
  const [countdown, setCountdown] = useState(REDIRECT_DELAY_SECONDS);
  const redirecting = done && !!redirectUrl;

  useEffect(() => {
    if (!redirecting || !redirectUrl) return;
    if (countdown <= 0) {
      // As given by the tenant — nothing appended.
      window.location.href = redirectUrl;
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, redirecting, redirectUrl]);

  return (
    <Shell branding={branding}>
      <div className="thank-you">
        <h1>¡Gracias!</h1>
        <p className="lead">Estamos procesando tu verificación.</p>
        {!done && <div className="spinner" aria-hidden="true" />}
        {done && !redirectUrl && (
          <p className="lead">
            Ya puedes cerrar esta ventana. Si necesitas ayuda, contacta a {branding.brandName || 'la empresa'}.
          </p>
        )}
        {redirecting && (
          <p className="redirect-note">
            Serás redirigido en {countdown} segundo{countdown === 1 ? '' : 's'}…
          </p>
        )}
      </div>
    </Shell>
  );
}
